import { $api } from "../generated/client";

type SizingExperimentResultsParams = {
	shopId: string;
	experimentId: string;
	fromTimestamp?: number;
	toTimestamp?: number;
};

// craftsman-ignore: TS002
export default function useSizingExperimentResults({
	shopId,
	experimentId,
	...params
}: SizingExperimentResultsParams) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/sizing/experiments/{experimentId}/results",
		{
			params: {
				path: { shopId, experimentId },
				query: params,
			},
			enabled: !!shopId && !!experimentId,
		},
	);
}
